function updateActiveSlide() {
	var controls = this.selector.parentElement.querySelector('.carousel__controls'),
		idx = this.currentSlide;
        
	for (var i = 0; i < controls.children.length; i++) {
		controls.children[i].classList.remove('current');
	}
	controls.children[idx].classList.add('current');
}

function addNavigation( instance ) {
    const children = instance.innerElements.length;
    if(children > 1) {
        const controls = document.createElement('div');
        controls.className = 'component-carousel__navigation';
        instance.selector.parentElement.appendChild(controls);

        for (let i = 0; i < instance.innerElements.length; i++) {
            const btn = document.createElement('button');
            btn.className = i == 0 ? 'current' : '';
            btn.innerHTML = '<span class="reader-only">carousel control dot</span>';
            btn.addEventListener('click', () => instance.goTo(i));
            controls.appendChild(btn);
        }
    }
}

function addControls( instance, perSlide ) {
    const children = instance.innerElements.length;
    if(children > 1 && ( children > perSlide || perSlide == 1 ) ) {
        // console.log( children, perSlide, children > perSlide )
        const navigation = document.createElement('div');
            navigation.className = 'row end container hide-md component-carousel__controls';
            instance.selector.parentElement.appendChild(navigation);
        const prev = document.createElement('button');
            prev.className = 'component-carousel__prev';
            prev.innerHTML = '<span class="reader-only">carousel previous arrow</span>';
            prev.addEventListener('click', () => instance.prev());
            navigation.appendChild(prev);
        const next = document.createElement('button');
            next.className = 'component-carousel__next';
            next.innerHTML = '<span class="reader-only">carousel next arrow</span>';
            next.addEventListener('click', () => instance.next());
            navigation.appendChild(next);
    }
}

module.exports = initCarousels = carousels => { 
    carousels.forEach( carousel => {
        const self = carousel;
        let options = {
            selector: self,
            // onChange: updateActiveSlide
        };
        self.getAttribute('data-loop') !== null ? options['loop'] = true : false;
        const itemsPerSlide = self.getAttribute('data-per-slide') || 1;
        if( itemsPerSlide > 1 ) {
            options['perPage'] = {
                900 : Number(self.getAttribute('data-per-slide')),
                640 : 1
            }
        }
        const thisSiema = new Siema( options );
        self.getAttribute('data-controls') !== null ? addControls( thisSiema,itemsPerSlide ) : false;
        self.getAttribute('data-navigation') !== null ? addNavigation( thisSiema,itemsPerSlide ) : false;
        thisSiema.resizeHandler();
    } );
}